import { memo, type ReactNode } from 'react';

export interface AppShellProps {
  readonly children: ReactNode;
  readonly className?: string;
  /** When true, applies analytics shell background tokens (PR-3B). */
  readonly analytics?: boolean;
}

/**
 * Analytics token wrapper only (`.an-shell` / `.an-shell--analytics` from `shared/styles/tailwind.css`).
 * Not a substitute for `EnterpriseShell` chrome — do not nest page padding, a second `<main>`, or a second `<h1>`.
 */
export const AppShell = memo<AppShellProps>(({ children, className = '', analytics = false }) => (
  <div className={`an-shell min-h-full ${analytics ? 'an-shell--analytics' : ''} ${className}`.trim()}>
    {children}
  </div>
));
AppShell.displayName = 'AppShell';
